import { render, staticRenderFns } from "./WorkplaceList.vue?vue&type=template&id=f0ca2f36&scoped=true&"
import script from "./WorkplaceList.vue?vue&type=script&lang=js&"
export * from "./WorkplaceList.vue?vue&type=script&lang=js&"
import style0 from "./WorkplaceList.vue?vue&type=style&index=0&id=f0ca2f36&lang=scss&scoped=true&"
import style1 from "./WorkplaceList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ca2f36",
  null
  
)

export default component.exports